import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;

// const API_URL = "http://192.168.122.63:8000/api/admin";

export default class UserService {


  static async getAllUsers(token) {
    try {
      const response = await axios.get(`${API_URL}/utilisateurs`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data;

      const gestionnaires = Array.isArray(data.gestionnaires) ? data.gestionnaires : [];
      const admins = Array.isArray(data.admins) ? data.admins : [];

      const utilisateursGestionnaires = gestionnaires.map(u => ({
        ...u,
        role: "gestionnaire",
        date_creation: u.date_creation ? new Date(u.date_creation).toLocaleDateString() : "-"
      }));

      const utilisateursAdmins = admins.map(u => ({
        ...u,
        role: "admin",
        date_creation: u.date_creation ? new Date(u.date_creation).toLocaleDateString() : "-"
      }));

      return {
        gestionnaires: utilisateursGestionnaires,
        admins: utilisateursAdmins
      };
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs :", error);
      throw error;
    }
  }





  static async addUser(newUser, token) {
    try {
      await axios.post(`${API_URL}/utilisateurs`, newUser, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      //  Retourne la réponse brute du backend pour affichage
      if (error.response) {
        throw {
          message: error.response.data.message || "Erreur inconnue.",
          errors: error.response.data.errors || null,
          status: error.response.status,
        };
      }
      throw { message: "Erreur réseau ou serveur injoignable." };
    }
  }

  static async sendEmail(id, token) {
    try {
      const response = await axios.post(`${API_URL}/utilisateurs/${id}/send-email`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; 
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email :", error);
      if (error.response) {
        throw {
          message: error.response.data.message || "Erreur inconnue.",
          status: error.response.status,
        };
      }
      throw { message: "Erreur réseau ou serveur injoignable." };
    }
  }

  static async updateUser(id, editData, token) {
    try {
      const payload = { ...editData };
      if (!payload.mot_de_passe_h) delete payload.mot_de_passe_h;

      await axios.put(`${API_URL}/utilisateurs/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error("Erreur lors de la modification :", error);
      throw error;
    }
  }

  static async deleteUser(id, role, token) {
    try {
      await axios.delete(`${API_URL}/utilisateurs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { current_role: role }, // ← champ requis
      });
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
      throw error;
    }
  }




  static async getProfile(id, token, role) {
    try {
      const baseUrl = role === "admin" ? API_URL : API_GESTIONNAIRE;
      const response = await axios.get(`${baseUrl}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du profil :", error);
      throw error.response?.data?.message || "Erreur lors de la récupération du profil.";
    }
  }

  static async updateProfile(id, updateData, token, role) {
    try {
      const baseUrl = role === "admin" ? API_URL : API_GESTIONNAIRE;
      const payload = { ...updateData };
      if (!payload.mot_de_passe_h) {
        delete payload.mot_de_passe_h;
        delete payload.current_password;
      }

      const response = await axios.put(`${baseUrl}/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du profil :", error);
      throw error.response?.data?.message || "Erreur lors de la mise à jour du profil.";
    }
  }
}

